import { useState } from 'react';
import { adminApi } from '@/api/endpoints';
import type { User } from '@/api/types';
import { Alert, Card, Spinner } from '@/components/ui';
import { useAsync } from '@/lib/useAsync';
import styles from './admin.module.css';

/**
 * Admin-Pflege der Kackhaufen-Auszeichnung (💩). Zugewiesenen Tippern wird das
 * Emoji in Tippübersicht + Gesamtübersicht direkt hinter dem Tippnamen angezeigt.
 */
export function AdminKackhaufenPage() {
  const { data, loading, error, reload } = useAsync<User[]>(
    (signal) => adminApi.listUsers('active', signal),
    [],
  );

  const [busyId, setBusyId] = useState<number | null>(null);
  const [actionError, setActionError] = useState<string | null>(null);

  async function toggle(user: User) {
    setBusyId(user.id);
    setActionError(null);
    try {
      await adminApi.setKackhaufen(user.id, !user.kackhaufen);
      reload();
    } catch (err) {
      setActionError(err instanceof Error ? err.message : 'Aktion fehlgeschlagen.');
    } finally {
      setBusyId(null);
    }
  }

  return (
    <>
      <p className="muted">
        💩 einem oder mehreren Tippern zuordnen. Erscheint danach direkt hinter dem Tippnamen in
        der Tippübersicht und der Gesamtübersicht.
      </p>

      {actionError && <Alert>{actionError}</Alert>}

      {loading && <Spinner label="Nutzer werden geladen…" />}
      {error && <Alert>{error}</Alert>}

      {!loading && !error && (data?.length ?? 0) === 0 && (
        <Card>
          <p className="muted">Keine aktiven Nutzer.</p>
        </Card>
      )}

      {!loading &&
        !error &&
        data?.map((u) => (
          <Card key={u.id}>
            <div className={styles.row}>
              <div className={styles.rowMain}>
                <div className={styles.rowTitle}>
                  {u.display_name}
                  {u.kackhaufen ? ' 💩' : ''}
                </div>
                <div className="muted">{u.email}</div>
              </div>
              <div className={styles.actions}>
                <button
                  type="button"
                  className={`${styles.chip} ${u.kackhaufen ? styles.chipOn : ''}`}
                  disabled={busyId === u.id}
                  onClick={() => void toggle(u)}
                >
                  💩 {u.kackhaufen ? 'entfernen' : 'zuweisen'}
                </button>
              </div>
            </div>
          </Card>
        ))}
    </>
  );
}
